import React from "react";
import BreadCrumb from "../../../Common/BreadCrumb";

const LoaderPage = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Loader" pageType="Elements" />
      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Border Spinner
            </h2>
            <div className="flex flex-wrap items-center gap-4">
              <div className="animate-spin inline-block size-8 border-[3px] border-l-transparent border-purple rounded-full"></div>
              <div className="animate-spin inline-block size-8 border-[3px] border-l-transparent border-info rounded-full"></div>
              <div className="animate-spin inline-block size-8 border-[3px] border-l-transparent border-success rounded-full"></div>
              <div className="animate-spin inline-block size-8 border-[3px] border-l-transparent border-warning rounded-full"></div>
              <div className="animate-spin inline-block size-8 border-[3px] border-l-transparent border-danger rounded-full"></div>
              <div className="animate-spin inline-block size-8 border-[3px] border-l-transparent border-black rounded-full"></div>
              <div className="animate-spin inline-block size-8 border-[3px] border-l-transparent border-muted rounded-full"></div>
              <div className="animate-spin inline-block size-8 border-[3px] border-l-transparent border-light rounded-full"></div>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Spinner Sizes
            </h2>
            <div className="flex flex-wrap items-center gap-3">
              <div className="animate-spin inline-block size-10 border-[3px] border-l-transparent border-purple rounded-full"></div>
              <div className="animate-spin inline-block size-9 border-[3px] border-l-transparent border-info rounded-full"></div>
              <div className="animate-spin inline-block size-8 border-[3px] border-l-transparent border-success rounded-full"></div>
              <div className="animate-spin inline-block size-7 border-[3px] border-l-transparent border-warning rounded-full"></div>
              <div className="animate-spin inline-block size-6 border-[3px] border-l-transparent border-danger rounded-full"></div>
              <div className="animate-spin inline-block size-5 border-[3px] border-l-transparent border-black rounded-full"></div>
              <div className="animate-spin inline-block size-4 border-[3px] border-l-transparent border-muted rounded-full"></div>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Spinner Sizes
            </h2>
            <div className="flex flex-wrap items-center gap-6">
              <div className="relative">
                <span className="inline-block size-5">
                  <span className="inline-flex w-full h-full rounded-full animate-ping bg-purple/50"></span>
                </span>
              </div>
              <div className="relative">
                <span className="inline-block size-5">
                  <span className="inline-flex w-full h-full rounded-full animate-ping bg-info/50"></span>
                </span>
              </div>
              <div className="relative">
                <span className="inline-block size-5">
                  <span className="inline-flex w-full h-full rounded-full animate-ping bg-success/50"></span>
                </span>
              </div>
              <div className="relative">
                <span className="inline-block size-5">
                  <span className="inline-flex w-full h-full rounded-full animate-ping bg-warning/50"></span>
                </span>
              </div>
              <div className="relative">
                <span className="inline-block size-5">
                  <span className="inline-flex w-full h-full rounded-full animate-ping bg-danger/50"></span>
                </span>
              </div>
              <div className="relative">
                <span className="inline-block size-5">
                  <span className="inline-flex w-full h-full rounded-full animate-ping bg-black/50"></span>
                </span>
              </div>
              <div className="relative">
                <span className="inline-block size-5">
                  <span className="inline-flex w-full h-full rounded-full animate-ping bg-muted/50"></span>
                </span>
              </div>
              <div className="relative">
                <span className="inline-block size-5">
                  <span className="inline-flex w-full h-full rounded-full animate-ping bg-light/50"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Spinner Custom
            </h2>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <div className="inline-block align-middle border-8 rounded-full animate-spin border-black/10 border-l-purple w-14 h-14"></div>
              <div className="animate-[spin_2s_linear_infinite] border-8 border-black/10 border-l-purple border-r-black rounded-full w-14 h-14 inline-block align-middle"></div>
              <div className="animate-[spin_3s_linear_infinite] border-8 border-r-light border-l-purple border-t-black border-b-success rounded-full w-14 h-14 inline-block align-middle"></div>
            </div>
          </div>
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Spinner Buttons
            </h2>
            <div className="flex flex-wrap gap-4">
              <button
                type="button"
                className="btn flex items-center gap-1.5 bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="inline-block h-5 w-5 animate-[spin_2s_linear_infinite] align-middle"
                >
                  <line x1="12" y1="2" x2="12" y2="6"></line>
                  <line x1="12" y1="18" x2="12" y2="22"></line>
                  <line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line>
                  <line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line>
                  <line x1="2" y1="12" x2="6" y2="12"></line>
                  <line x1="18" y1="12" x2="22" y2="12"></line>
                  <line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line>
                  <line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>
                </svg>
                Primary
              </button>
              <button
                type="button"
                className="btn flex items-center gap-1.5 bg-success border border-success rounded-md text-white transition-all duration-300 hover:bg-success/[0.85] hover:border-success/[0.85]"
              >
                <span className="inline-block align-middle border-2 border-white rounded-full size-5 animate-spin border-l-transparent"></span>
                Success
              </button>
              <button
                type="button"
                className="btn flex items-center gap-2 bg-black border border-black rounded-md text-white transition-all duration-300 hover:bg-black/[0.85] hover:border-black/[0.85]"
              >
                <span className="inline-block rounded-full size-3 animate-ping bg-white/30 group-hover:bg-white "></span>
                Black
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default LoaderPage;
